export const getUserRole = (user) => {
    const roleId = String(user?.role.id);
    if (roleId === '2') return user?.barwisCoach;
    if (roleId === '3') return user?.externalAdmin;
    if (roleId === '4') return user?.externalCoach;
    return null;
};

export const getModuleConfig = (user) => {
    const role = getUserRole(user);
    if (!role) return {};

    const isOverride = Boolean(role?.access_control_override);
    if (isOverride) {
        const overrideConfig = JSON.parse(role?.access_configuration) || {};
        return overrideConfig?.module_config || {};
    }

    return role?.accessTemplate?.module_config ? JSON.parse(role?.accessTemplate?.module_config) : {};
}

export const hasModuleAccess = (user, moduleConfig, moduleId) => {
    const role = String(user?.role.id || '');
    if (role === '1') return true;
    return Boolean(moduleConfig?.[moduleId]?.enabled);
}